import {Dialog, Transition} from '@headlessui/react';
import {Context} from '../../../../Helpers/Auth';
import SelectComponent from '../../../Selects/SelectComponent';
import React, {useState, Fragment, useRef, useContext, useEffect} from 'react';
import {ExclamationTriangleIcon} from '@heroicons/react/24/outline';
import {useTranslation} from 'react-i18next';
import Datepicker from 'react-tailwindcss-datepicker';

import i18n from '../../../../i18n';
import {useHistory} from 'react-router-dom';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {ToastContainer} from 'react-toastify';
import {getVIES} from '../../../../pages/requests';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import moment from 'moment';

// import { Container } from './styles';

function Detalhes({info}) {
    const {t} = useTranslation();
    const history = useHistory();
    const {
        optionsCortesia,
        optionsFuncao,
        optionsOrigem,
        optionsInteresse,

        optionsStatus,
        optionsCategoria,
        optionsMarca,
        optionsNacionaisInternacionais,
        optionsTipo,
        optionsModelo,

        optionsRepresentante,

        optionsMoeda,
        optionsLingua,

        leadCortesia,
        setLeadCortesia,
        leadNome,
        setLeadNome,
        leadApelido,
        setLeadApelido,
        leadRazaoSocial,
        setLeadRazaoSocial,
        leadFuncao,
        setLeadFuncao,
        leadTelemovel,
        setLeadTelemovel,
        leadEmail,
        setLeadEmail,
        leadNIF,
        setLeadNIF,
        leadOrigem,
        setLeadOrigem,
        leadStatus,
        setLeadStatus,
        leadInteresse,
        setLeadInteresse,
        leadFollowUp,
        setLeadFollowUp,
        leadCategoria,
        setLeadCategoria,
        leadMarca,
        setLeadMarca,
        leadNacionalInternacional,
        setLeadNacionalInternacional,
        leadTipo,
        setLeadTipo,
        leadModelo,
        setLeadModelo,
        leadRepresentante,
        setLeadRepresentante,

        // leadMoeda,
        // setLeadMoeda,
        leadLingua,
        setLeadLingua,

        leadComentario,
        setLeadComentario,

        editarLead,

        //

        msgErroCortesia,
        msgErroApelido,
        msgErroRazaoSocial,
        msgErroNome,
        msgErroTelemovel,
        msgErroEmail,
        msgErroContribuinte,
        msgErroMoeda,
        msgErroLingua,
        msgErroOrigem,
        msgErroStatus,
        msgErroInteresse,
        msgErroFollowUp,
        msgErroMarca,
        msgErroCategoria,
        msgErroNacionalInternacional,
        msgErroTipo,
        msgErroModelo,
        msgErroRepresentante,

        setMsgErroCortesia,
        setMsgErroApelido,
        setMsgErroRazaoSocial,
        setMsgErroNome,
        setMsgErroCategoria,
        setMsgErroTelemovel,
        setMsgErroEmail,
        setMsgErroContribuinte,
        setMsgErroMoeda,
        setMsgErroLingua,
        setMsgErroOrigem,
        setMsgErroStatus,
        setMsgErroInteresse,
        setMsgErroFollowUp,
        setMsgErroMarca,
        setMsgErroNacionalInternacional,
        setMsgErroTipo,
        setMsgErroModelo,
        setMsgErroRepresentante,
        //

        leadMoradas,
        setLeadMoradas,
        leadMoradaID,
        setLeadMoradaID,
        leadMoradaPais,
        setLeadMoradaPais,
        leadMoradaMorada,
        setLeadMoradaMorada,
        leadMoradaCodigoPostal,
        setLeadMoradaCodigoPostal,
        leadMoradaCidade,
        setLeadMoradaCidade,
        leadMoradaContacto,
        setLeadMoradaContacto,
        leadMoradaDescricao,
        setLeadMoradaDescricao,
        leadMoradaEmail,
        setLeadMoradaEmail,
        leadMoradaEnderecoDefeito,
        setLeadMoradaEnderecoDefeito,
        paises,
        setOnChangeForm,
    } = info;
    const {nome} = useContext(Context);

    var modules = {
        // table: true, // disable table module

        toolbar: [
            [{header: [1, 2, 3, false]}],
            ['bold', 'italic', 'underline', 'strike'],
            [{script: 'sub'}, {script: 'super'}],
            ['image', 'code-block'],
            [{align: []}],
            [{list: 'ordered'}, {list: 'bullet'}],
            [{indent: '-1'}, {indent: '+1'}], // outdent/indent
            [{color: []}, {background: []}], // dropdown with defaults from theme
            ['clean'],
            ['link'],
        ],
    };

    function getVies(nif) {
        debugger;
        let countryCode = nif?.slice(0, 2);
        let vatNumber = nif?.slice(2);

        getVIES(countryCode.toUpperCase(), vatNumber)
            .then(res => {
                const pais = countryCode.toUpperCase();
                if (res.data.success && res.data.vies.valida) {
                    const foundCountry = paises.find(e => e.value === pais);

                    if (foundCountry) {
                        setLeadMoradaPais(foundCountry);
                    }
                    setLeadRazaoSocial(res.data.vies.nome);
                    if (leadMoradas.length === 1) {
                        var a = res.data.vies.morada.split(/(\d{4}-\d{3})/);

                        setLeadMoradas([
                            {
                                id: 'E001',
                                pais: foundCountry,
                                morada: a[0],
                                codigoPostal: a[1],
                                cidade: a[2],
                                enderecoDefeito: true,
                                descricao: '',
                            },
                            // linha Vazia
                            {
                                id: '',
                                pais: null,
                                morada: '',
                                codigoPostal: '',
                                cidade: '',
                                enderecoDefeito: false,
                                descricao: '',
                            },
                        ]);
                    }
                    toast.success(t('nifVies'), {
                        position: 'top-right',
                        autoClose: 6000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: 'light',
                    });
                } else {
                    toast.warn(t('semNifVies'), {
                        position: 'top-right',
                        autoClose: 6000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: 'light',
                    });
                }
            })
            .catch(error => {
                toast.warn(error, {
                    position: 'top-right',
                    autoClose: 6000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: 'light',
                });
            });
    }
    return (
        <>
            <div className="grid gap-6 mb-3 md:grid-cols-2">
                <div>
                    <label htmlFor="nif" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('nif')}
                    </label>
                    <input
                        value={leadNIF}
                        maxLength={20}
                        type="tel"
                        id="nif"
                        className={`${
                            editarLead ? 'bg-white dark:bg-gray-900' : 'bg-gray-50 dark:bg-gray-800'
                        } border border-gray-300 text-gray-900 text-lg rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                        pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
                        required
                        onChange={e => {
                            setOnChangeForm(true);
                            setLeadNIF(e.target.value);
                            setMsgErroContribuinte('');
                            if (e.target.value.toUpperCase().length == 11) {
                                getVies(e.target.value.toUpperCase());
                            }
                        }}
                        disabled={!editarLead}
                    />
                    {msgErroContribuinte && <small className="text-red-500">{msgErroContribuinte}</small>}
                </div>
                <div>
                    <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('email')}
                    </label>
                    <input
                        value={leadEmail}
                        maxLength={80}
                        type="tel"
                        id="email"
                        className={`${
                            editarLead ? 'bg-white dark:bg-gray-900' : 'bg-gray-50 dark:bg-gray-800'
                        } border border-gray-300 text-gray-900 text-lg rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                        required
                        onChange={e => {
                            setOnChangeForm(true);
                            setLeadEmail(e.target.value);
                            setMsgErroEmail('');
                        }}
                        disabled={!editarLead}
                    />
                    {msgErroEmail && <small className="text-red-500">{msgErroEmail}</small>}
                </div>
            </div>
            <div className="grid gap-6 mb-3 md:grid-cols-3">
                <div>
                    <label htmlFor="last_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('cortesia')}*
                    </label>
                    <SelectComponent
                        isDisabled={!editarLead}
                        options={optionsCortesia}
                        value={leadCortesia}
                        onChange={e => {
                            setOnChangeForm(true);
                            setLeadCortesia(e);
                            setMsgErroCortesia('');
                        }}
                        noOptionsMessage={t('semopcoes')}
                        placeholder={t('selecioneOpcao')}
                    />
                    {msgErroCortesia && <small className="text-red-500">{msgErroCortesia}</small>}
                </div>
                <div>
                    <label htmlFor="nome" className={`block mb-2 text-sm font-medium text-gray-900 dark:text-white`}>
                        {t('nome')}*
                    </label>
                    <input
                        value={leadNome}
                        maxLength={20}
                        type="text"
                        id="nome"
                        className={`${editarLead ? 'bg-white dark:bg-gray-900' : 'bg-gray-50 dark:bg-gray-800'} ${
                            msgErroNome ? 'is-invalid-class dark:border-red-500 dark:focus:ring-red-500 dark:focus:border-red-500 border-red-500 focus:ring-red-500 focus:border-red-500' : ''
                        } border border-gray-300 text-gray-900 text-lg rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                        required
                        onChange={e => {
                            setOnChangeForm(true);
                            setLeadNome(e.target.value);
                            setMsgErroNome('');
                        }}
                        disabled={!editarLead}
                    />
                    {msgErroNome && <small className="text-red-500">{msgErroNome}</small>}
                </div>
                <div>
                    <label htmlFor="apelido" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('apelido')}*
                    </label>
                    <input
                        value={leadApelido}
                        maxLength={60}
                        type="text"
                        id="apelido"
                        className={`${
                            editarLead ? 'bg-white dark:bg-gray-900' : 'bg-gray-50 dark:bg-gray-800'
                        } border border-gray-300 text-gray-900 text-lg rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                            msgErroApelido ? 'is-invalid-class dark:border-red-500 dark:focus:ring-red-500 dark:focus:border-red-500 border-red-500 focus:ring-red-500 focus:border-red-500' : ''
                        }`}
                        required
                        onChange={e => {
                            setOnChangeForm(true);
                            setLeadApelido(e.target.value);
                            setMsgErroApelido('');
                        }}
                        disabled={!editarLead}
                    />
                    {msgErroApelido && <small className="text-red-500">{msgErroApelido}</small>}
                </div>
                <div>
                    <label htmlFor="razaoSocial" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('nomeEmpresa')}
                    </label>
                    <input
                        value={leadRazaoSocial}
                        maxLength={60}
                        type="text"
                        id="razaoSocial"
                        className={`${
                            editarLead ? 'bg-white dark:bg-gray-900' : 'bg-gray-50 dark:bg-gray-800'
                        } border border-gray-300 text-gray-900 text-lg rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                            msgErroRazaoSocial ? 'is-invalid-class dark:border-red-500 dark:focus:ring-red-500 dark:focus:border-red-500 border-red-500 focus:ring-red-500 focus:border-red-500' : ''
                        }`}
                        onChange={e => {
                            setOnChangeForm(true);
                            setLeadRazaoSocial(e.target.value);
                            setMsgErroRazaoSocial('');
                        }}
                        disabled={!editarLead}
                    />
                    {msgErroRazaoSocial && <small className="text-red-500">{msgErroRazaoSocial}</small>}
                </div>
                <div>
                    <label htmlFor="funcao" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('funcao')}
                    </label>
                    <SelectComponent
                        id={'funcao'}
                        isDisabled={!editarLead}
                        options={optionsFuncao}
                        value={leadFuncao}
                        onChange={e => {
                            setOnChangeForm(true);
                            setLeadFuncao(e);
                        }}
                        noOptionsMessage={t('semopcoes')}
                        placeholder={t('selecioneOpcao')}
                    />
                </div>

                <div>
                    <label htmlFor="phone" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('telemovel')}*
                    </label>
                    <input
                        value={leadTelemovel}
                        maxLength={20}
                        type="tel"
                        id="phone"
                        className={`${
                            editarLead ? 'bg-white dark:bg-gray-900' : 'bg-gray-50 dark:bg-gray-800'
                        } border border-gray-300 text-gray-900 text-lg rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                            msgErroTelemovel ? 'is-invalid-class dark:border-red-500 dark:focus:ring-red-500 dark:focus:border-red-500 border-red-500 focus:ring-red-500 focus:border-red-500' : ''
                        }`}
                        pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
                        required
                        onChange={e => {
                            setOnChangeForm(true);
                            setLeadTelemovel(e.target.value);
                            setMsgErroTelemovel('');
                        }}
                        disabled={!editarLead}
                    />
                    {msgErroTelemovel && <small className="text-red-500">{msgErroTelemovel}</small>}
                </div>
            </div>

            <div className="grid gap-6 mb-3 md:grid-cols-3">
                <div>
                    <label htmlFor="origem" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('origem')}*
                    </label>
                    <SelectComponent
                        id={'origem'}
                        isDisabled={!editarLead}
                        options={optionsOrigem}
                        value={leadOrigem}
                        onChange={e => {
                            setOnChangeForm(true);
                            setLeadOrigem(e);
                            setMsgErroOrigem('');
                        }}
                        noOptionsMessage={t('semopcoes')}
                        placeholder={t('selecioneOpcao')}
                    />
                    {msgErroOrigem && <small className="text-red-500">{msgErroOrigem}</small>}
                </div>

                <div>
                    <label htmlFor="status" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('status')}
                    </label>
                    <SelectComponent
                        id={'status'}
                        isDisabled={!editarLead}
                        options={optionsStatus}
                        value={leadStatus}
                        onChange={e => {
                            setOnChangeForm(true);
                            setLeadStatus(e);
                            setMsgErroStatus('');
                        }}
                        noOptionsMessage={t('semopcoes')}
                        placeholder={t('selecioneOpcao')}
                    />
                    {msgErroStatus && <small className="text-red-500">{msgErroStatus}</small>}
                </div>

                <div>
                    <label htmlFor="interesse" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('interesse')}
                    </label>
                    <SelectComponent
                        id={'interesse'}
                        isDisabled={!editarLead}
                        options={optionsInteresse}
                        value={leadInteresse}
                        onChange={e => {
                            setOnChangeForm(true);
                            setLeadInteresse(e);
                            setMsgErroInteresse('');
                        }}
                        noOptionsMessage={t('semopcoes')}
                        placeholder={t('selecioneOpcao')}
                    />
                    {msgErroInteresse && <small className="text-red-500">{msgErroInteresse}</small>}
                </div>

                <div>
                    <label htmlFor="followup" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('followup')}*
                    </label>
                    <Datepicker
                        id={'followup'}
                        displayFormat="DD/MM/YYYY"
                        minDate={moment()}
                        // maxDate={today}
                        useRange={false}
                        asSingle={true}
                        value={leadFollowUp}
                        onChange={newValue => {
                            setOnChangeForm(true);
                            setLeadFollowUp(newValue);
                            // handleDataChange(newValue);
                            setMsgErroFollowUp('');
                        }}
                        inputClassName={`rounded-[8px] w-full  border border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                            !editarLead ? 'bg-gray-50 dark:bg-gray-800' : 'bg-white dark:bg-gray-900'
                        } `}
                        disabled={!editarLead || leadStatus?.value !== 5}
                    />
                    {msgErroFollowUp && <small className="text-red-500">{msgErroFollowUp}</small>}
                </div>
            </div>
            <div className="grid gap-6 mb-3 md:grid-cols-4">
                <div>
                    <label htmlFor="marca" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('categoria')}*
                    </label>
                    <SelectComponent
                        id={'categoria'}
                        isDisabled={!editarLead}
                        options={optionsCategoria}
                        value={leadCategoria}
                        onChange={e => {
                            setOnChangeForm(true);
                            setLeadCategoria(e);
                            setMsgErroCategoria('');
                        }}
                        noOptionsMessage={t('semopcoes')}
                        placeholder={t('selecioneOpcao')}
                    />
                    {msgErroCategoria && <small className="text-red-500">{msgErroCategoria}</small>}
                </div>
                <div>
                    <label htmlFor="marca" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('marca')}
                    </label>
                    <SelectComponent
                        id={'marca'}
                        isDisabled={!editarLead}
                        options={optionsMarca.filter(o => !leadCategoria?.length === 0 || o.dep === leadCategoria?.value)}
                        value={leadMarca}
                        onChange={e => {
                            setOnChangeForm(true);
                            setLeadMarca(e);
                        }}
                        noOptionsMessage={t('semopcoes')}
                        placeholder={t('selecioneOpcao')}
                    />
                </div>

                <div>
                    <label htmlFor="tipo" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('nacionalInternacional')}
                    </label>
                    <SelectComponent
                        id={'tipo'}
                        isDisabled={!editarLead}
                        options={optionsNacionaisInternacionais.filter(o => !leadMarca?.length === 0 || o.dep === leadMarca?.value)}
                        value={leadNacionalInternacional}
                        onChange={e => {
                            setOnChangeForm(true);
                            setLeadNacionalInternacional(e);
                        }}
                        noOptionsMessage={t('semopcoes')}
                        placeholder={t('selecioneOpcao')}
                    />
                </div>

                <div>
                    <label htmlFor="modelo" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('tipo')}
                    </label>
                    <SelectComponent
                        id={'modelo'}
                        isDisabled={!editarLead}
                        options={optionsTipo.filter(o => !leadNacionalInternacional?.length === 0 || o.dep === leadNacionalInternacional?.value)}
                        value={leadTipo}
                        onChange={e => {
                            setOnChangeForm(true);
                            setLeadTipo(e);
                        }}
                        noOptionsMessage={t('semopcoes')}
                        placeholder={t('selecioneOpcao')}
                    />
                </div>
                <div>
                    <label htmlFor="modelo" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('modelo')}
                    </label>
                    <SelectComponent
                        id={'modelo'}
                        isDisabled={!editarLead}
                        options={optionsModelo.filter(o => !leadTipo?.length === 0 || o.dep === leadTipo?.value)}
                        value={leadModelo}
                        onChange={e => {
                            setOnChangeForm(true);
                            setLeadModelo(e);
                        }}
                        noOptionsMessage={t('semopcoes')}
                        placeholder={t('selecioneOpcao')}
                    />
                </div>
            </div>
            <div className="grid gap-6 mb-3 md:grid-cols-3">
                <div>
                    <label htmlFor="representante" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('representante')}
                    </label>
                    <SelectComponent
                        id={'representante'}
                        isDisabled={!editarLead}
                        options={optionsRepresentante}
                        value={leadRepresentante}
                        onChange={e => {
                            setOnChangeForm(true);
                            setLeadRepresentante(e);
                        }}
                        noOptionsMessage={t('semopcoes')}
                        placeholder={t('selecioneOpcao')}
                    />
                </div>
            </div>
            <div className="grid gap-6 mb-3 md:grid-cols-1 mt-12">
                <label htmlFor="representante" className="block text-xl font-medium text-gray-900 dark:text-white">
                    {t('comentario')}
                </label>
                <ReactQuill
                    readOnly={!editarLead}
                    // style={{height: '50%', width: '90%', marginTop: 15}}
                    className={` h-[50%] w-[90%] `}
                    modules={modules}
                    //theme="snow"
                    value={leadComentario}
                    onChange={setLeadComentario}
                />
            </div>
            <ToastContainer />
        </>
    );
}

export default Detalhes;
